"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadMore = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _ui = require("../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var LoadMoreWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 20px;\n"])));
var LoadMore = function LoadMore(_ref) {
  var onClick = _ref.onClick,
    isLoading = _ref.isLoading;
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(LoadMoreWrapper, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    color: "secondary",
    small: true,
    loading: isLoading,
    onClick: onClick
  }, t('loadMore')));
};
exports.LoadMore = LoadMore;